<template>
  <v-row>
    <v-app-bar-nav-icon 
      class="hidden-md-and-up mt-8 ml-6" 
      color="black" 
      @click="drawer = !drawer"
    >
      <v-icon>mdi-dots-vertical</v-icon>
    </v-app-bar-nav-icon>
    <v-navigation-drawer
      app
      clipped
      append
      floating
      v-if="isLogin"
      disable-resize-watcher
      v-model="drawer"
    >
      <v-list dense nav class="mt-1">
        <v-list-item-group
          color="#5E10BC"
          class="mt-16 pl-2"
          width=228
        >
          <template>
            <v-list-item link :to="{ name: 'user', params: { user_code: getUserCode }}" class="mt-2">
              <v-list-item-avatar tile size="20">
                <v-img src="../../assets/topic_list_icon.svg" alt="icon" max-height="20" max-width="20"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">トピック一覧</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link :to="{ name: 'user_edit', params: { mode: 'base'}}" active-class class="mt-2">
              <v-list-item-avatar tile size="20">
                <v-img src="../../assets/user_edit_icon.svg" alt="icon" max-height="20" max-width="20"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">プロフィール編集</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link :to="{ name: 'favorite_topics' }" class="mt-2">
              <v-list-item-avatar tile size="20">
                <v-img src="../../assets/favorite_topic_icon.svg" alt="icon" max-height="20" max-width="20"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">お気に入りトピック一覧</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link :to="{ name: 'favorite_users' }" class="mt-2">
              <v-list-item-avatar tile size="20">
                <v-img src="../../assets/favorite_user_icon.svg" alt="icon" max-height="20" max-width="20"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">お気に入りユーザー一覧</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="isDrawerLayout()" link :to="{ name: 'topic_create' }" class="mt-2">
              <v-list-item-avatar tile size="20">
                <v-img src="../../assets/topic_create_icon.svg" alt="icon" max-height="20" max-width="20"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">トピック作成</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="isDrawerLayout()"  link :to="{ name: 'draft_list' }" class="mt-2">
              <v-list-item-avatar tile size="20">
                <v-img src="../../assets/draft_list_icon.svg" alt="icon" max-height="20" max-width="20"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">
                  下書き
                  <v-avatar
                    v-if="user.draft_topic_count > 0"
                    color="#FF7171"
                    size="16"
                  ><span class="white--text">{{ getDraftTopicCount }}</span>
                  </v-avatar>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </v-row>
</template>
<script>
export default {
  name: 'ProfileSideBar',
  data() {
    return {
      drawer: true,
      loading: true,
      user: {
        icon_url: '',
        name: '',
        introduction_text: '',
        user_code: '',
        draft_topic_count: '',
      },
      favorited: false,
      topics: {},
      selectedItem: 0,
      is_auth: false,
      total_count: null,
      bucketUrl: process.env.VUE_APP_IMAGE_BUCKET_URL,
      isDisabled: true
    }
  },
  computed: {
    isFavorited: function() {
      return this.favorited
    },
    isMyPage: function() {
      return this.getUserCode === this.$route.params.user_code;
    },
    isLogin: function () {
      return this.$store.getters["auth/isAuth"];
    },
    isExistTopic() {
      return this.total_count > 0;
    },
    icon: function() {
      return this.user.icon_url
    },
    getUserCode: function() {
      return this.$store.getters['auth/isUserCode']
    },
    getDraftTopicCount: function() {
      return this.user.draft_topic_count;
    },
  },
  methods: {
    // お気に入り
    favorite: function() {
      this.isDisabled = true;
      if(this.favorited){
        this.$store.dispatch('favorite/userDelete', this.user.user_code)
          .then(() => {
            this.favorited = false;
            this.isDisabled = false;
          })
      } else {
        this.$store.dispatch('favorite/userRegister', this.user.user_code)
          .then(() => {
            this.favorited = true;
            this.isDisabled = false;
          })
      }
    },
    searchTag($tag) {
      this.$router.push({ path: '/search_result', query: { tag: $tag } })
    },
    isUnRead: function(item) {
      return item.unread
    },
    isDrawerLayout() {
      if (
        this.$vuetify.breakpoint.name === 'md' ||
        this.$vuetify.breakpoint.name === 'sm' ||
        this.$vuetify.breakpoint.name === 'xs'
      ) {
        return false;
      }
      return true;
    },
  },
  mounted() {
    if(this.isMyPage) {
      this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/profile')
        .then(response => {
          this.user = response.data
          this.loading = false;
          this.total_count = this.user.topics.length;
          this.is_auth = true
          this.$store.dispatch('favorite/users')
            .then(response => {
              response.map(user => {
                if(this.user.user_code === user.user_code) {
                  this.favorited = true;
                }
              })
              this.isDisabled = false;
            })
        });
    }
  },
  created() {
    this.drawer = this.isDrawerLayout();
  }
};
</script>
